import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";

import { Particles } from "./Sections/components/Particles";
import { NavigationTabs } from "./Sections/components/NavigationTabs";
import { Bento } from "./Sections/components/Bento";
import { tiles } from "./Sections/components/Bento/tiles";
import { t } from "@/i18n-js/instance";
import { Hero } from "./Sections/components/Hero";

const i18nRoot = "eoy_recap_2025.sections";

export const EoyRecapApp = () => {
  const { width, height } = useWindowSize();

  return (
    <main className="relative min-h-screen bg-[#0F0F35]">
      <ReactConfetti
        width={width}
        height={height}
        style={{
          zIndex: 999999,
        }}
        recycle={false}
        tweenDuration={6000}
        numberOfPieces={100}
        gravity={0.15}
        wind={0.05}
        colors={[
          "#a855f7",
          "#9333ea",
          "#7e22ce",
          "#6b21a8",
          "#ffffff",
          "#fbbf24",
          "#f59e0b",
        ]}
        initialVelocityY={-20}
        initialVelocityX={15}
      />
      <Particles />
      <NavigationTabs />
      <Hero />
      <Bento
        tiles={tiles}
        accentColor="#24287E"
        title={t([i18nRoot, "community.title"])}
      />
    </main>
  );
};
